var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16309 4C1.16309 2.34315 2.50623 1 4.16309 1H8.16309H9.72045C10.5161 1 11.2792 1.31607 11.8418 1.87868L14.2844 4.32132C14.847 4.88393 15.1631 5.64699 15.1631 6.44264V8V12C15.1631 13.6569 13.8199 15 12.1631 15H4.16309C2.50623 15 1.16309 13.6569 1.16309 12V4Z",
    stroke: "#7D899D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1628 14.9998V10.9998C12.1628 9.89519 11.2674 8.99976 10.1628 8.99976H6.16284C5.05827 8.99976 4.16284 9.89519 4.16284 10.9998V14.9998",
    stroke: "#7D899D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36279 1V3.5C5.36279 4.05228 5.81051 4.5 6.36279 4.5H9.96279C10.5151 4.5 10.9628 4.05228 10.9628 3.5V1",
    stroke: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveView);
export default __webpack_public_path__ + "static/media/save-view.73252ade.svg";
export { ForwardRef as ReactComponent };